
import { Component, Vue } from 'vue-property-decorator';
import { diyOrderTemplate, delDiyOrderTemplate, diyOrder, diyStaticsOrderExport } from '@/api/statistics';
import { UserModule } from '../../store/modules/user';
import { IPagination } from '@/types';
import FormSearch from './components/searchIndex.vue'
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'StatisticsSreportForms',
  components: {
    FormSearch
  }
})
export default class extends Vue {
  private maxHeight= window.innerHeight - 140;
  private yy = new Date().getFullYear();
  private mm = new Date().getMonth();
  private dd = new Date().getDate();
  private dimensionSelected:any = {};
  private dimensionItems:any = [];

  private doEdit(row:any) {
    let rows = {}
    for (let i = 0; i < this.dimensionItems.length; i++) {
      if (row.id === this.dimensionItems[i].id) {
        rows = this.dimensionItems[i]
      }
    }
    this.$router.push({
      path: 'reportTemplate',
      query: { templateEdit: '1', data: JSON.stringify(rows) }
    });
  }

  private newTemplateHandle() {
    this.$router.push({
      path: 'reportTemplate',
      query: { templateEdit: '0' }
    });
  }

  handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  private loading = false
  private tableData = {
    list: [],
    fields: []
  }
  private selectedData: string[] = [];

  // 导出Excel
  private dialogExportVisible=false
  private radioExport=''
  private checkboxExport=[];

  handleExport() {
    this.dialogExportVisible = true;
  }
  private closeExport() {
    this.radioExport = '';
    this.dialogExportVisible = false;
  }
  private confirmExport() {
    this.export();
  }
  private export() {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      servicer_company_id: '',
      template_id: this.dimensionSelected.id,
      is_customer: this.isCus ? '1' : '',
      start_time: new Date(this.yy, this.mm, 1, 0, 0, 0).getTime() / 1000,
      end_time: new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime() / 1000,
      merge_rows: this.radioExport === '1' ? '1' : '0',
      all_merge_rows: this.radioExport === '2' ? '1' : '0',
      filter_task_state: this.checkboxExport && this.checkboxExport.length > 0 ? this.checkboxExport.join(',') : '',
      ...this.searchData,
      is_ser_dept:this.isSerAll ? '0' : '1'
    };
    diyStaticsOrderExport(params).then(res => {
      this.dialogExportVisible = false;
      this.radioExport = '';
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private radioExportClick(val: any) {
    this.radioExport = this.radioExport === val ? '0' : val;
  }
  private isCus=true;
  private reportType:any = false;
  private activeName = ''
  private isSerAll = false;
  created() {
    this.isCus = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.StatisticsCusDiyOrder);
    this.diyOrderTemplate();
    //获取路由path 
    this.isSerAll = this.$route.path == "/Statistics/reportForms" ? true : false;
  }
  private diyOrderTemplate() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    diyOrderTemplate(params).then(res => {
      this.dimensionItems = res.data;
      this.activeName = this.dimensionItems[0].id + ''
      if (this.dimensionItems && this.dimensionItems.length > 0) {
        let data:any = [];
        data.push(...res.data);
        let price:any = {};
        price.id = 'price';
        price.name = '费用';
        data.push(price);
        let part:any = {};
        part.id = 'part';
        part.name = '备件';
        data.push(part);

        this.dimensionItems[0].btnType = 'primary';
        this.dimensionItems[0].btnPlain = false;
        this.dimensionSelected = this.dimensionItems[0];

        this.getList();
      } else {
        this.$router.push({
          path: 'reportTemplate',
          query: { templateEdit: '0' }
        });
      }
    }).catch(err => {
      let msg = err.msg;
      this.$router.push({
        path: 'reportTemplate',
        query: { templateEdit: '0' }
      });
    });
  }
  private delTemplate(item:any) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          template_id: item.id
        };
        delDiyOrderTemplate(params).then(res => {
          this.showSuccessMsg('操作成功');
          this.diyOrderTemplate();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      })
      .catch(() => {});
  }

  private searchData: any = {}
  private isCanClick:boolean=true;
  private formSearchData(val: any) {
    if (!this.isCanClick) {
      this.showErrorMsg('请勿连续点击')
      return
    }
    this.isCanClick = false;
    this.searchData = val;
    if (val) {
      this.pagination.currentPage = 1;
      this.getList()
    }
  }
  private getList() {
    //增加参数 是否是维修部门自定义报表  is_ser_dept
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      template_id: this.dimensionSelected.id,
      is_customer: this.isCus ? '1' : '',
      start_time: new Date(this.yy, this.mm, 1, 0, 0, 0).getTime() / 1000,
      end_time: new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime() / 1000,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      ...this.searchData,
      is_ser_dept:this.isSerAll ? '0' : '1'
    };
    this.tableData.list = [];
    this.loading = true;
    diyOrder(params).then(res => {
      this.isCanClick = true;
      this.loading = false;
      if (res.data) {
        this.tableData = res.data;
        if (this.tableData.fields) {
          this.tableData.fields = this.tableData.fields.filter((t: any) => {
            return t.name !== '';
          });
        }
        this.pagination.total = res.data.count;
        this.reportType = res.data.type;
      } else {
        this.tableData = {
          list: [],
          fields: [] };
        this.pagination.total = 0;
      }
    }).catch(err => {
      this.isCanClick = true;
      this.tableData = {
        list: [],
        fields: [] };
      this.pagination.total = 0;
      this.loading = false;
      // let msg = err.msg;
      this.showErrorMsg(err.msg);
    });
  }

  private handleClick() {
    if (this.activeName === 'price') {
      let price:any = {};
      price.id = 'price';
      price.name = '费用';
      this.dimensionSelected = price;
    } else if (this.activeName === 'part') {
      let part:any = {};
      part.id = 'part';
      part.name = '备件';
      this.dimensionSelected = part;
    } else {
      let arr = this.dimensionItems.filter((v:any) => {
        return v.id === this.activeName
      })
      if (arr && arr.length > 0) {
        this.dimensionSelected = arr[0];
      }
    }
    this.getList()
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
